import { render, staticRenderFns } from "./ListDataImportEditor.vue?vue&type=template&id=646688b6&"
import script from "./ListDataImportEditor.vue?vue&type=script&lang=js&"
export * from "./ListDataImportEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports